import { uriConverter } from "~/util/uri-converter";

/**
 * セッションIDが存在しない場合に「自動ログインスクリプト」を実行する関数
 * @see https://git.dmm.com/navismith/extension-auto-login#%E5%B0%8E%E5%85%A5%E6%89%8B%E9%A0%86
 *
 * @example
 * ```tsx
 * const isLoggedIn = !!getCookie(COOKIE.LOGIN_SESSION_ID.KEY)
 * const isAutoLogin = !!getCookie(COOKIE.HAS_ALT_HASH.KEY)
 * if (!isLoggedIn && isAutoLogin) autoLoginScript()
 * ```
 */
export const autoLoginScript = () => {
  const currentEncodeUrl = uriConverter.encode(location.href);

  const headTagElement = document.getElementsByTagName("head")[0] as HTMLHeadElement;

  const scriptTagElement = document.createElement("script");
  scriptTagElement.type = "text/javascript";
  scriptTagElement.src = process.env.NEXT_PUBLIC_AUTO_LOGIN_DOMAIN;
  scriptTagElement.crossOrigin = "anonymous";
  scriptTagElement.setAttribute("id", "auto-login");
  scriptTagElement.setAttribute("data-encoded", currentEncodeUrl);

  headTagElement.prepend(scriptTagElement);
};
